import React from "react"

import { useTranslation } from "react-i18next"

import { TagAudience } from "services/bonus/type"

import { TagMultiSelect } from "../shared/TagMultiSelect"

interface TagAudiencePickerProps {
  value: string[]
  onChange: (slugs: string[]) => void
  audience?: TagAudience
  audienceLoading: boolean
  disabled?: boolean
}

export const TagAudiencePicker: React.FC<TagAudiencePickerProps> = ({ value, onChange, audience, audienceLoading, disabled }) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  return (
    <>
      <label className="block text-sm font-medium text-gray-300 mb-2">
        {t("bonus2.players.selectTags")}
        <span className="text-gray-500 ml-2 text-xs">{t("bonus2.players.selectTagsHint")}</span>
      </label>
      <TagMultiSelect value={value} onChange={onChange} disabled={disabled} />

      {value.length > 0 && (
        <div className="mt-3">
          {audienceLoading && <p className="text-xs text-gray-400">{t("bonus2.players.countingPlayers")}</p>}

          {!audienceLoading && audience && !audience.overCap && (
            <p className="text-sm text-gray-300">{t("bonus2.players.audienceCount", { count: audience.total })}</p>
          )}

          {!audienceLoading && audience?.overCap && (
            <div className="rounded-lg border border-amber-500/50 bg-amber-500/10 px-3 py-2">
              <p className="text-sm text-amber-200">{t("bonus2.players.audienceOverCap", { count: audience.total, cap: audience.cap })}</p>
              <p className="mt-1 text-xs text-amber-200/80">{t("bonus2.players.audienceOverCapHint")}</p>
            </div>
          )}
        </div>
      )}
    </>
  )
}
